import { Button, Form, Select, message } from 'antd';
import { Risk, User } from '../../models';
import { apiClient, apiErrorMessage } from '../../utils';
import { useEffect, useState } from 'react';

export function NewRiskActionPage(props: { risk?: Risk; onSaved: () => void }) {
  const [users, setUsers] = useState<User[]>();
  const [loading, setLoading] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false);

  const loadUsers = () => {
    setUsersLoading(true);
    apiClient
      .get('users')
      .then(response => {
        setUsers(response.data);
        setUsersLoading(false);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
        setUsersLoading(false);
      });
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const onFinish = (values: any) => {
    setLoading(true);

    const body = {
      ...values,
      riskId: props.risk?.id,
    };

    apiClient
      .post('risk-actions', body)
      .then(() => {
        message.success('Çözüm önerisi kaydedildi.');
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form layout="vertical" onFinish={onFinish}>
      <Form.Item name="solutionType" label="Çözüm yöntemi" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <Select>
          <Select.Option value="KAIZEN">Kaizen</Select.Option>
          <Select.Option value="FIVE_S">5S</Select.Option>
          <Select.Option value="VISUAL_ACTION">Görsel işlem</Select.Option>
          <Select.Option value="TWTTP">TWTTP</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item name="responsibleUserId" label="Çözüm sorumlusu" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <Select
          showSearch
          loading={usersLoading}
          filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {users?.map(u => (
            <Select.Option value={u.id}>{u.fullNameId}</Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item style={{ marginTop: '2rem' }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Gönder
        </Button>
      </Form.Item>
    </Form>
  );
}
